/**
 * 块级别的loading
 */

import React from 'react';

export function BlockLoading() {
    return (
        <div className="weui-loadmore">
            <i className="weui-loading"></i>
            <span className="weui-loadmore__tips">正在加载...</span>
        </div>
    );
}

export function BlockEmpty() {
    return (
        <div className="weui-loadmore weui-loadmore_line">
            <span className="weui-loadmore__tips">暂无数据</span>
        </div>
    );
}
